export const warehouseTableKeys = [
  {
    name: "Name",
    key: "name",
  },
  {
    name: "Code",
    key: "code",
  },
  {
    name: "Description",
    key: "description",
  },
];
